// 261029 P1 B2(a) — dựng «plan hạt giống» cho FilmPlanProvider từ chi tiết plan mà trang workflow ĐÃ có (`getEventPlan`), để bước Tài sản không phải chờ `getPlan` mới mở PlanGate.
// THUẦN (không antd) ⇒ test được dưới jest. Chỉ khớp đúng planId; hạt giống thiếu `shots` của scene (thẻ nhân vật chỉ dùng id / orderIndex / heading) — `getPlan` vẫn chạy và thay bản đầy đủ khi về.
import type { EventPlan, FilmPlan, FilmScene } from '../../types/film';

export function seedPlanFromEventPlan(detail: EventPlan | null | undefined, planId: string, storyId: string): FilmPlan | null {
  const p = detail?.plan;
  if (!detail || !p || !planId || p.id !== planId) return null;
  const scenes: FilmScene[] = (detail.scenes ?? []).map((sc: any) => ({
    id: sc.id, orderIndex: sc.orderIndex, heading: sc.heading ?? null, location: sc.location ?? null, summary: sc.summary ?? null,
    timeOfDay: sc.timeOfDay ?? null, shots: [],
  }));
  return {
    id: p.id, sourceStoryId: storyId, sourceChapterIds: [], name: p.name ?? null, status: p.status, videoProvider: p.videoProvider,
    logline: p.logline ?? null, visualBible: p.visualBible ?? null, createdAt: '', scenes,
    exportUrl: p.exportUrl ?? null, promptMode: p.promptMode, flowVersion: p.flowVersion ?? null,
  };
}
